import { apiClient } from './api'

export interface Movement {
  id: string
  fromYardId: string | number
  toYardId?: string | number
  toWarehouseId?: string | number
  destinationType?: 'yard' | 'warehouse'
  movementType: 'add' | 'remove' | 'transfer'
  boxType: 'deeps' | 'super' | 'shallow'
  quantity: number
  movementDate?: string
  createdAt?: string
}

export interface CreateMovementPayload {
  fromYardId: string | number
  toYardId?: string | number
  toWarehouseId?: string | number
  destinationType?: 'yard' | 'warehouse'
  movementType: 'add' | 'remove' | 'transfer'
  boxType: 'deeps' | 'super' | 'shallow'
  quantity: number
  movementDate?: string
  userId?: string | number
}

/**
 * Gets movements
 * @param params - Query params
 * @returns Promise with movement list
 */
export function getMovements(params?: { yardId?: string | number }) {
  return apiClient.get<Movement[]>('/movements', { params })
}

/**
 * Creates a new movement
 * @param payload - Movement payload
 * @returns Promise with movement
 */
export function createMovement(payload: CreateMovementPayload) {
  return apiClient.post<Movement>('/movements', payload)
}
